import {
  GET_TOUCHES,
  CLEAR_TOUCHES,
  DELETE_TOUCH,
  SET_CURRENT,
  CLEAR_CURRENT,
  FILTER_TOUCHES,
  CLEAR_FILTER,
  TOUCHES_ERROR,
  GET_DROPDOWNS
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case GET_TOUCHES:
      //console.log('touchesReducer', action.payload);
      return {
        ...state,
        touches: action.payload,
        loading: false
      };
    case GET_DROPDOWNS:
      //console.log("appNames", action.payload);
      return {
        ...state,
        dropdowns: action.payload,
        loading: false
      };
    case DELETE_TOUCH:
      //console.log(action);
      return {
        ...state,
        touches: state.touches.filter(t => t.id !== action.payload),
        loading: false
      };
    case CLEAR_TOUCHES:
      return {
        ...state,
        touches: null,
        filtered: null,
        error: null,
        current: null,
        loading: false
      };
    case SET_CURRENT:
      return {
        ...state,
        current: action.payload
      };
    case CLEAR_CURRENT:
      return {
        ...state,
        current: null
      };
    case FILTER_TOUCHES:
      return {
        ...state,
        filtered: state.touches.filter(t => {
          const regex = new RegExp(`${action.payload}`, "gi");
          if (t.clientName) {
            return t.appName.match(regex) || t.clientName.match(regex);
          } else {
            return t.appName.match(regex);
          }
        }),
        loading: false
      };
    case CLEAR_FILTER:
      return {
        ...state,
        filtered: null,
        loading: false
      };
    case TOUCHES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    default:
      return state;
  }
};
